(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/inactive-member.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/inactive-member.js');
'use strict';

const {
  MemberPopover,
  MemberPopoverItem
} = svs.arena.pages.teams.components;
const {
  MemberSendEmail,
  MemberName
} = svs.arena.pages.teams.teamMembers;
const {
  putActivateMemberAsync
} = svs.arena.service.teamsService;
const {
  changeMemberActivity
} = svs.arena.store.teams.actions;
const {
  useRemoveMember
} = svs.arena.shared.hooks;
const {
  showActivateMemberSuccess,
  showTechnicalError
} = svs.arena.pages.teams.dialogs;
const InactiveMember = _ref => {
  let {
    member: {
      customerId,
      firstName,
      lastName
    },
    isLeader,
    teamId,
    teamName
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [isShowEmail, setIsShowEmail] = React.useState(false);
  const isInactive = true;
  const {
    onRemoveMember
  } = useRemoveMember(teamId, teamName, customerId, firstName, lastName, isInactive);
  const onShowEmail = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'action_members_inactive',
      opt_label: 'show_email_field'
    };
    svs.components.analytics.trackEvent(track);
    setIsShowEmail(true);
  };
  const activate = async () => {
    const {
      error
    } = await putActivateMemberAsync(customerId, teamId);
    if (error) {
      if (error.code === '22 108') {
        dispatch(changeMemberActivity({
          teamId,
          customerId,
          active: true
        }));
        return;
      }
      showTechnicalError();
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: 'action_members_inactive',
        opt_label: 'activate'
      };
      svs.components.analytics.trackEvent(track);
      dispatch(changeMemberActivity({
        teamId,
        customerId,
        active: true
      }));
      showActivateMemberSuccess(firstName, lastName);
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "u-flex margin-v-1"
  }, React.createElement("div", {
    className: "u-flex-grow-1"
  }, React.createElement("div", {
    className: "padding-left-1 f-400 data-hj-suppress"
  }, React.createElement(MemberName, {
    className: "padding-left-1",
    firstName: firstName,
    lastName: lastName
  }))), React.createElement("div", {
    className: "align-right"
  }, isLeader && React.createElement("div", {
    className: "padding-right-1"
  }, React.createElement(MemberPopover, null, React.createElement(MemberPopoverItem, {
    onClick: onShowEmail
  }, " Skicka e-post "), React.createElement(MemberPopoverItem, {
    onClick: activate
  }, " Aktivera "), React.createElement(MemberPopoverItem, {
    onClick: onRemoveMember
  }, " Ta bort "))))), isShowEmail && React.createElement(MemberSendEmail, {
    customerId: customerId,
    firstName: firstName,
    isInactive: true,
    lastName: lastName,
    onHide: () => setIsShowEmail(false),
    teamId: teamId
  }));
};
svs.arena.pages.teams.teamMembers.InactiveMember = InactiveMember;

 })(window);